import type { PropsWithChildren } from 'react';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import { viewerApi } from '../../../api';
import { useAuth } from '../../../auth';

export const MfaProvider = ({ children }: PropsWithChildren<{}>) => {
  const { authenticated, user } = useAuth();
  const history = useHistory();
  const mfaActive = user?.mfaActive === true;

  useEffect(() => {
    if (!authenticated || mfaActive) {
      return;
    }

    void viewerApi.getViewerPreferences().then(res => {
      if (!res.data.data?.mfaPrompt) {
        return;
      }

      history.push('/register-two-factor-auth');
    });
  }, [authenticated, history, mfaActive]);

  return <>{children}</>;
};
